import { createSelector } from 'reselect';
import * as notificationsHelpers from './notificationsHelpers';

export const getNotificationsState = state => state?.notifications || {};

export const getNotifications = createSelector(
  [getNotificationsState],
  state => state.notifications || []
);

export const isNotificationOpen = notificationId =>
  createSelector([getNotificationsState], state => {
    return notificationsHelpers.isNotificationOpen(state, notificationId);
  });
